
// 小部件
import { get, post, postJson, put, deleteApi } from '../axios2'

const RESOURCE_BASE_PATH = '/smallComponentForBController';

//入会信息设置
export const liveCardSave = p => postJson(`${RESOURCE_BASE_PATH}`, p);
//查询入会信息设置
export const getLiveCard = p => get(`${RESOURCE_BASE_PATH}/${p.type}/${p.joinType}`);
// 获取部件已投放类型
export const getLiveStatusCard = p => get(`${RESOURCE_BASE_PATH}/put-status`);
// 使用模板
export const putLiveCard = p => put(`${RESOURCE_BASE_PATH}/${p.type}`);

// 数据统计-汇总
export const getLiveSum = p => get(`/small-component-stats/sum`, p);

// 数据统计-列表数据
export const getLiveList = p => get(`/small-component-stats/table`, p);

// 数据统计-折线图
export const getLiveChart = p => get(`/small-component-stats/chart`, p);

// 记录列表
export const getLiveRecord = p => postJson(`/small-component-record/list`, p);

// 今日招募
export const getTodayNum = p => get(`/small-component-stats/today-num`);

// 根据商家获取反作弊配置
export const preventCheat = p => get(`/seller-prevent-cheat`);

export const savePreventCheat = p => postJson(`/seller-prevent-cheat`, p);


